import { render, staticRenderFns } from "./total-messages-type.vue?vue&type=template&id=5852e893&scoped=true&"
import script from "./total-messages-type.vue?vue&type=script&lang=js&"
export * from "./total-messages-type.vue?vue&type=script&lang=js&"
import style0 from "./total-messages-type.vue?vue&type=style&index=0&id=5852e893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852e893",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
